export enum CustomerSwitchStatus {
  notStarted = 'notStarted',
  pending = 'pending',
  complete = 'complete',
  failed = 'failed',
}
